const SRC_ROOT = '/assets';

const IMAGES_ROOT = `${SRC_ROOT}/images`;

export const SCREENS_ASSETS = `${IMAGES_ROOT}/screens`;

const MAP_ASSETS = `${IMAGES_ROOT}/shared/map`;

export const USER_PIN = {
  webp: `${MAP_ASSETS}/user-pin.webp`,
  png: `${MAP_ASSETS}/user-pin.png`,
};
